// language=HTML
const template = `
    <article class="carer-contracts">
        <md-content>
            <h1 class="md-display-2 section-title">Carer Contracts</h1>

            <installation-breadcrumbs></installation-breadcrumbs>

            <md-card class="app-list-card" ng-if="installation.hasCarerContractTypes">
                <app-loading ng-if="fetching" layout-padding></app-loading>

                <md-list ng-if="!fetching">
                    <md-list-item ng-repeat="type in carerContractTypes" class="md-2-line">
                        <md-icon class="md-avatar-icon">content_paste</md-icon>

                        <div class="md-list-item-text">
                            <h3>{{ type.description }}</h3>
                            <p>{{ type.hourly_rate / 100 | currency }}/h</p>
                        </div>
                    </md-list-item>
                </md-list>
            </md-card>

            <form autocomplete="off" name="form"
                  class="data-form"
                  ng-submit="createContractType($event)"
                  ng-disabled="creating">

                <md-card class="app-form-card">
                    <md-card-title>
                        <h2>Add a carer contract type</h2>
                    </md-card-title>

                    <md-card-content>
                        <carer-contract-type-create
                            contract-type="newContractType"
                            form="form"
                            control="formControl">
                        </carer-contract-type-create>
                    </md-card-content>

                    <md-card-actions layout="row" layout-align="end">
                        <md-button type="submit"
                                   class="md-raised md-primary"
                                   ng-disabled="creating || form.$invalid">
                            Create
                        </md-button>
                    </md-card-actions>
                </md-card>
            </form>
        </md-content>
    </article>
`;

CarerContractsController.$inject = [
    '$app',
    '$carerContractTypeFetcher',
    '$errorHandler',
    '$installation',
    '$scope',
    '$state',
];

function CarerContractsController($app, $carerContractTypeFetcher, $errorHandler, $installation, $scope, $state) {
    $scope.installation = $installation;
    $scope.creating = false;
    $scope.fetching = false;
    $scope.newContractType = {};

    $scope.formControl = {};

    $scope.createContractType = createContractType;

    fetchContractTypes();

    function fetchContractTypes() {
        $scope.fetching = true;

        $carerContractTypeFetcher
            .all()
            .then(
                response => {
                    $scope.carerContractTypes = response.data;
                },
                error => {
                    $errorHandler.handle(error);
                },
            )
            .finally(() => {
                $scope.fetching = false;
            });
    }

    /**
     * Send the new carer contract type to the server.
     * @return {void}
     */
    function createContractType() {
        const ranges = $scope.formControl.validateHourlyRateRanges();

        if (ranges === false) {
            return;
        }

        const rates = $scope.formControl.validateNonProRataRates();

        if (rates === false) {
            return;
        }

        $scope.creating = true;

        const toast = $app.progressToast('Creating contract type');

        const firstRun = !$installation.hasCarerContractTypes;

        $carerContractTypeFetcher
            .create({
                ...$scope.newContractType,
                hourly_rate_ranges: ranges,
                non_pro_rata_rates: rates,
            })
            .then(result => {
                $app.successToast('Contract type created!');

                $scope.carerContractTypes.push(result.data);
                $scope.newContractType = {};

                $installation.hasCarerContractTypes = true;

                if (firstRun) {
                    $state.go($installation.nextStep);
                }
            })
            .catch(error => {
                $errorHandler.handle(error, $scope.form);
            })
            .finally(() => {
                $scope.creating = false;
                toast.hide();
            });
    }
}

export { template, CarerContractsController as controller };
